import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Faltan las variables de entorno de Supabase')
}

// Configuración optimizada para gestión automática de sesiones
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Auto-refresh de tokens habilitado (crítico para evitar expiración)
    autoRefreshToken: true,

    // Persistir sesión en localStorage para mantener login entre recargas
    persistSession: true,

    // Detectar sesión de otras pestañas/ventanas (sincronización cross-tab)
    detectSessionInUrl: true,

    // Storage backend (localStorage es el default, pero lo explicitamos)
    storage: window.localStorage,

    // Key para almacenar la sesión en localStorage
    storageKey: 'supabase.auth.token',

    // PKCE flow para mejor seguridad (vs implicit flow)
    flowType: 'pkce',

    // Debug logs temporalmente desactivados para debugging
    debug: false // Cambiar a process.env.NODE_ENV === 'development' para reactivar
  },

  // Headers globales para todas las peticiones
  global: {
    headers: {
      'x-application-name': 'chat-flock'
    }
  }
})

// Module-level PASSWORD_RECOVERY detection.
// The PKCE code exchange emits PASSWORD_RECOVERY before React mounts any components
// (AuthContext blocks rendering with {!loading && children}). By listening at the
// module level we capture the event regardless of React's lifecycle timing.
let _passwordRecoveryDetected = false

supabase.auth.onAuthStateChange((event) => {
  if (event === 'PASSWORD_RECOVERY') {
    _passwordRecoveryDetected = true
  }
})

export function consumePasswordRecovery() {
  if (_passwordRecoveryDetected) {
    _passwordRecoveryDetected = false
    return true
  }
  return false
} 